import {FC, useEffect} from "react";
import Close from "../Svg/Close";
import {useTranslation} from "react-i18next";
import {setSEO} from "../../utils/seo";

const NotFound:FC = () => {
    const {t} = useTranslation();

    useEffect(() => {
        setSEO(null, t('notfound.title'), t('notfound.description'));
    }, []);

    return <div className="flex h-full full__height flex-col items-center justify-center text-center px-13">
        <div className="bg-red-400 flex w-[78px] h-[78px] mx-auto justify-center items-center rounded-full outline-20 outline-disabled-50"><Close /></div>
        <h1 className="title font-bold mt-10">{t('notfound.title')}</h1>
        <p className="mt-3 text-disabled-500">{t('notfound.description')}</p>
    </div>
}

export default NotFound;